import { useDebugValue, useEffect } from "react";

export function useIntervalEffect(fn, ms, castOnEffect = false) {
  useEffect(() => {
    if (castOnEffect) fn()

    const interval = setInterval(() => fn(), ms)

    return () => {
      clearInterval(interval)
    }
  }, [fn, ms, castOnEffect])

  useDebugValue(`interval scheduled for every ${ms}ms`)
}
